import React from "react";
import { Modal } from "antd";
import i18n from "i18next";
import RawHtml from "../Auth/RawHtml";

export function showHtml(endpoint: string) {
  fetch(`/legal/${endpoint}?culture=${i18n.language}`)
    .then((value) => value.text())
    .then((html) => {
      Modal.info({
        title: "",
        width: "min(1000px, calc(100vw - 32px))",
        okButtonProps: { style: { display: "none" } },
        content: <RawHtml html={html} />,
        maskClosable: true,
      });
    });
}
